
<div class="card cumulative-return-chart">
    <div class="card-header"><h1>Cumulative Return</h1></div>
    <div class="card-body">
        <app-chart-placeholder [loaded]="loaded"></app-chart-placeholder>
        <highcharts-chart *ngIf="loaded"
                          [options]="chartOptions"
                          [constructorType]="chartConstructor"
                          (chartInstance)="setChartInstance($event)"
                          style="width: 100%; height: auto; display: block;"
        ></highcharts-chart>
    </div>
</div>
